var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bulletinList"}},[_vm._v("bulletinList")])
}
var staticRenderFns = []

export { render, staticRenderFns }